import * as React from 'react';
import {TextField} from '@sail/ui';

export const Uncontrolled = () => (
  <TextField
    onChange={(e) => {
      // eslint-disable-next-line no-console
      console.log(e);
    }}
    label="First name"
  />
);
